/**
 * Detects device orientation and manages the landscape prompt overlay.
 * Shows a prompt when mobile devices are in portrait mode,
 * hides it when in landscape.
 */

const MOBILE_MAX_WIDTH = 768;

function isMobileDevice(): boolean {
  const isSmallViewport = window.innerWidth <= MOBILE_MAX_WIDTH
    || window.innerHeight <= MOBILE_MAX_WIDTH;
  const hasTouchSupport = ('ontouchstart' in window)
    || (navigator.maxTouchPoints > 0);

  return isSmallViewport || hasTouchSupport;
}

function isPortraitOrientation(): boolean {
  // Always use viewport dimensions as the primary check.
  // screen.orientation API may not reflect viewport changes in emulation.
  return window.innerHeight > window.innerWidth;
}

function updateOrientationPrompt(): void {
  const prompt = document.getElementById('orientation-prompt');
  const container = document.getElementById('game-container');

  if (!prompt || !container) {
    return;
  }

  const shouldShowPrompt = isMobileDevice() && isPortraitOrientation();

  prompt.style.display = shouldShowPrompt ? 'flex' : 'none';
  container.style.display = shouldShowPrompt ? 'none' : 'flex';
}

export function initOrientationDetector(): void {
  // Initial check
  updateOrientationPrompt();

  // Listen for orientation changes via Screen Orientation API
  if (screen.orientation) {
    screen.orientation.addEventListener('change', updateOrientationPrompt);
  }

  // Listen for resize events (catches orientation changes and viewport resizes)
  window.addEventListener('resize', updateOrientationPrompt);

  // Listen for orientationchange event (older mobile browsers)
  window.addEventListener('orientationchange', () => {
    // Small delay to let the browser update dimensions
    setTimeout(updateOrientationPrompt, 100);
  });
}
